import {
  Award,
  Crown,
  Flame,
  LucideIcon,
  Rocket,
  Star,
  Target,
  Trophy,
  Zap,
} from "lucide-react";
import toast from "react-hot-toast";

import { BadgeDefinition } from "@/lib/gamification";

const iconMap: Record<string, LucideIcon> = {
  Award,
  Crown,
  Flame,
  Rocket,
  Star,
  Target,
  Trophy,
  Zap,
};

export const showBadgeEarnedNotification = (badge: BadgeDefinition) => {
  toast.custom(
    (t) => <BadgeEarnedNotification badge={badge} visible={t.visible} />,
    { duration: 6000, id: `badge-${badge.slug}` }
  );
};

function BadgeEarnedNotification({
  badge,
  visible,
}: {
  badge: BadgeDefinition;
  visible: boolean;
}) {
  const Icon = iconMap[badge.icon] || Trophy;

  return (
    <div
      className={
        visible ? "animate-notification-enter" : "animate-notification-leave"
      }
    >
      <div className="flex items-center space-x-3 bg-white dark:bg-slate-800 rounded-full px-4 py-3 shadow-lg min-w-[280px]">
        {/* ping effect */}
        <div className="absolute w-12 h-12 left-4 top-3 inset-0 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full animate-ping animat" />
        <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-2xl relative">
          <Icon className="w-6 h-6" />
          <div className="absolute -top-1 -right-1 bg-yellow-400 text-yellow-900 text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
            ★
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-slate-900 dark:text-white truncate">
            Badge earned!
          </div>
          <div className="text-sm text-slate-600 dark:text-slate-300">
            {badge.name}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BadgeEarnedNotification;
